import colorStyleConstants from '@qmulus/ui/styles/color.export.module.scss';

import {
  withLruCache,
} from './lru-cache';

type TQmulusColorPalette = {
  colorIndex: number,
  color: string,
};
export const QMULUS_COLOR_PALETTE: TQmulusColorPalette[] = [];
for (let colorIndex = 105; colorIndex <= 223; colorIndex++) {
  // color 166 does not exist on the palette
  if (colorIndex === 166) {
    continue;
  }
  QMULUS_COLOR_PALETTE.push({
    colorIndex,
    color: colorStyleConstants[`color${colorIndex}`],
  });
}

/**
 * A hashmap to quickly look up a certain colorIndex by its color
 */
export const QMULUS_COLOR_PALETTE_COLOR_TO_COLOR_INDEX: Map<string, number> = new Map(
  QMULUS_COLOR_PALETTE.map((color) => {
    return [
      color.color,
      color.colorIndex,
    ];
  }),
);

export function generateRandomColor(): string {
  return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
}

export const colorPaletteGrayscale = {
  'color-100': '#ffff',
  'color-101': '#fafafaff',
  'color-102': '#f5f5f5ff',
  'color-103': '#eeef',
  'color-104': '#bdbdbdff',
  'color-105': '#9e9e9eff',
  'color-106': '#757575ff',
  'color-107': '#616161ff',
  'color-108': '#424242ff',
  'color-109': '#212121ff',
  'color-110': '#191919ff',
  'color-111': '#141414ff',
  'color-112': '#0f0f0fff',
  'color-113': '#0a0a0aff',
  'color-114': '#000f',
};

export const colorPaletteWithoutGrayscale = {
  'color-115': '#f5f9ffff',
  'color-116': '#d0e1fdff',
  'color-117': '#abc9fbff',
  'color-118': '#85b2f9ff',
  'color-119': '#609af8ff',
  'color-120': '#3b82f6ff',
  'color-121': '#326fd1ff',
  'color-122': '#295bacff',
  'color-123': '#204887ff',
  'color-124': '#183462ff',
  'color-125': '#f4fcf7ff',
  'color-126': '#caf1d8ff',
  'color-127': '#a0e6baff',
  'color-128': '#76db9bff',
  'color-129': '#4cd07dff',
  'color-130': '#22c55eff',
  'color-131': '#1da750ff',
  'color-132': '#188a42ff',
  'color-133': '#136c34ff',
  'color-134': '#0e4f26ff',
  'color-135': '#fefceaff',
  'color-136': '#fdf9c9ff',
  'color-137': '#fcf097ff',
  'color-138': '#f8e164ff',
  'color-139': '#f3ce49ff',
  'color-140': '#e2b53eff',
  'color-141': '#c18d30ff',
  'color-142': '#986523ff',
  'color-143': '#7d501fff',
  'color-144': '#6a411cff',
  'color-145': '#f3fbfdff',
  'color-146': '#c3edf5ff',
  'color-147': '#94e0edff',
  'color-148': '#35c4dcff',
  'color-149': '#06b6d4ff',
  'color-150': '#059bb4ff',
  'color-151': '#047f94ff',
  'color-152': '#036475ff',
  'color-153': '#024955ff',
  'color-154': '#fef6faff',
  'color-155': '#fad3e7ff',
  'color-156': '#f7b0d3ff',
  'color-157': '#f38ec0ff',
  'color-158': '#f06bacff',
  'color-159': '#ec4899ff',
  'color-160': '#c93d82ff',
  'color-161': '#a5326bff',
  'color-162': '#822854ff',
  'color-163': '#5e1d3dff',
  'color-164': '#f7f7feff',
  'color-165': '#dadafcff',
  'color-167': '#bcbdf9ff',
  'color-168': '#9ea0f6ff',
  'color-169': '#8183f4ff',
  'color-170': '#6366f1ff',
  'color-171': '#5457cdff',
  'color-172': '#4547a9ff',
  'color-173': '#363885ff',
  'color-174': '#282960ff',
  'color-175': '#f3fbfbff',
  'color-176': '#c7eeeaff',
  'color-177': '#9ae0d9ff',
  'color-178': '#6dd3c8ff',
  'color-179': '#41c5b7ff',
  'color-180': '#14b8a6ff',
  'color-181': '#119c8dff',
  'color-182': '#0e8174ff',
  'color-183': '#0b655bff',
  'color-184': '#084a42ff',
  'color-185': '#fff8f3ff',
  'color-186': '#feddc7ff',
  'color-187': '#f2b29dff',
  'color-188': '#fba86fff',
  'color-189': '#fa8e42ff',
  'color-190': '#e5673eff',
  'color-191': '#ae510fff',
  'color-192': '#893f0cff',
  'color-193': '#642e09ff',
  'color-194': '#f7f8f9ff',
  'color-195': '#dadee3ff',
  'color-196': '#bcc3cdff',
  'color-197': '#9fa9b7ff',
  'color-198': '#818ea1ff',
  'color-199': '#64748bff',
  'color-200': '#556376ff',
  'color-201': '#465161ff',
  'color-202': '#37404cff',
  'color-203': '#282e38ff',
  'color-204': '#fbf7ffff',
  'color-205': '#ead6fdff',
  'color-206': '#dab6fcff',
  'color-207': '#c996faff',
  'color-208': '#b975f9ff',
  'color-209': '#a855f7ff',
  'color-210': '#8f48d2ff',
  'color-211': '#763cadff',
  'color-212': '#5c2f88ff',
  'color-213': '#432263ff',
  'color-214': '#fff5f5ff',
  'color-215': '#ffd0ceff',
  'color-216': '#ffaca7ff',
  'color-217': '#ff8780ff',
  'color-218': '#ff6259ff',
  'color-219': '#ff3d32ff',
  'color-220': '#d9342bff',
  'color-221': '#b32b23ff',
  'color-222': '#8c221cff',
  'color-223': '#661814ff',
  'color-224': '#495057ff',
  'color-225': '#1d4ed8ff',
  'color-226': '#696cffff',
  'color-227': '#1ea97cff',
  'color-228': '#cc8925ff',
  'color-229': '#ff5757ff',
  'color-230': '#f97316ff',
  'color-231': '#65d2e4ff',
  'color-232': '#6c757dff',
  'color-233': '#a0a0a0ff',
  'color-234': '#e6a892ff',
  'color-235': '#8b9097ff',
  'color-236': '#d0d1d4ff',
  'color-237': '#ffef',
  'color-238': '#e24c4cff',
  'color-239': '#00ff',
  'color-240': '#3d7362ff',
  'color-241': '#033765ff',
  'color-242': '#994f00ff',
  'color-243': '#469000ff',
  'color-244': '#ad0884ff',
  'color-245': '#a52a2aff',
  'color-246': '#d46477ff',
  'color-247': '#3585a4ff',
  'color-248': '#825f',
  'color-249': '#4a9f',
  'color-250': '#e75a2cff',
  'color-251': '#e8edf3ff',
};

export const colorPalette = {
  ...colorPaletteGrayscale,
  ...colorPaletteWithoutGrayscale,
};

/**
 * @param hex represents rgb hex with or without "hash", for example: 'fc1' '#fdbc12'
 * @returns array of numbers as 16 radix numbers representing "r" "g" and "b"
 */
export function hexToRgbNumberArray(hex: string): [number, number, number] {
  let cleanHex = hex.replace(/^#/, '');
  if (cleanHex.length === 3) {
    cleanHex = cleanHex.split('').map((char) => char + char).join('');
  }
  const bigint = parseInt(cleanHex, 16);
  return [
    (bigint >> 16) & 255,
    (bigint >> 8) & 255,
    bigint & 255,
  ];
}

/**
 * Converts an RGB array to a hex color code.
 *
 * @function rgbNumberArrayToHex
 * @param {number[]} rgb - An array containing the RGB values.
 * @returns {string} The hex color code.
 * @throws {Error} If the input is not a valid RGB array.
 *
 * @example
 * // Convert RGB to hex
 * rgbNumberArrayToHex([255, 0, 0]); // "#ff0000"
 * rgbNumberArrayToHex([0, 255, 0]); // "#00ff00"
 * rgbNumberArrayToHex([0, 0, 255]); // "#0000ff"
 */
export function rgbNumberArrayToHex(rgb: number[]): string {
  if (!Array.isArray(rgb) || rgb.length !== 3 || rgb.some((n) => n < 0 || n > 255 || !Number.isInteger(n))) {
    throw new Error('Invalid RGB array');
  }

  return `#${rgb.map((numericColorValue) => numericColorValue.toString(16).padStart(2, '0')).join('')}`;
}

/**
 * Converts individual RGB values to a hex color code.
 *
 * @function rgbToHex
 * @param {number} red - The red component (0-255).
 * @param {number} green - The green component (0-255).
 * @param {number} blue - The blue component (0-255).
 * @returns {string} The hex color code.
 * @throws {Error} If any component is out of range or not an integer.
 *
 * @example
 * // Convert RGB to hex
 * rgbToHex(255, 0, 0); // "#ff0000"
 * rgbToHex(0, 255, 0); // "#00ff00"
 * rgbToHex(0, 0, 255); // "#0000ff"
 */
export function rgbToHex(red: number, green: number, blue: number): string {
  return rgbNumberArrayToHex([
    red,
    green,
    blue,
  ]);
}

/**
 * Computes the WCAG relative luminance of a hex color.
 * Uses the IEC 61966-2-1 sRGB linearization threshold of 0.04045.
 * Results are memoized in an LRU cache (max 512 entries).
 *
 * @see https://www.w3.org/TR/WCAG22/#dfn-relative-luminance
 *
 * @param hexColor - hex color string (with or without '#'), e.g. '#ff0000' or 'ff0000'
 * @returns luminance value between 0 (black) and 1 (white)
 */
export const computeColorLuminance = withLruCache((hexColor: string): number => {
  const [
    r,
    g,
    b,
  ] = hexToRgbNumberArray(hexColor);

  return 0.2126 * convertChannelToLinear(r / 255)
    + 0.7152 * convertChannelToLinear(g / 255)
    + 0.0722 * convertChannelToLinear(b / 255);
}, 512);

/**
 * Helper function to linearize an RGB color value
 *
 * @see https://www.w3.org/TR/WCAG22/#dfn-relative-luminance
 * @param rgbChannel
 */
function convertChannelToLinear(rgbChannel: number): number {
  if (rgbChannel <= 0.04045) {
    return rgbChannel / 12.92;
  }
  return ((rgbChannel + 0.055) / 1.055) ** 2.4;
}

export const colorPaletteWithoutGrayscaleLuminiscenseList = Object.entries(colorPaletteWithoutGrayscale).map(([
  key,
  value,
]) => ({
  cssVarName: key,
  cssColorValue: value,
  luminance: computeColorLuminance(value),
}));

/**
 * Calculate the contras ratio according to WCAG 2.2
 *
 * @see https://www.w3.org/TR/WCAG22/#dfn-contrast-ratio
 *
 * @param l1 - relative luminance of color 1
 * @param l2 - relative luminance of color 1
 */
function contrastRatio(l1: number, l2: number): number {
  const lighter = Math.max(l1, l2);
  const darker = Math.min(l1, l2);
  return (lighter + 0.05) / (darker + 0.05);
}

const DARK_TEXT_COLOR = '#000000';
const BRIGHT_TEXT_COLOR = '#ffffff';

/**
 * Returns the matching font color for a given background color.
 *
 * It chooses the font color with the highest contrast.
 * This does not guarantee the minimum required contrast specified by W3C.
 *
 * @param color - hex color string (with or without '#'), e.g. '#ff0000'
 * @returns '#000000' for light backgrounds, '#ffffff' for dark backgrounds
 * @see https://www.w3.org/TR/WCAG22/#contrast-minimum
 */
export const getContrastForRgbString = withLruCache((color: string) => {
  const colorLuminance = computeColorLuminance(color);
  const whiteLuminance = computeColorLuminance(BRIGHT_TEXT_COLOR);
  const blackLuminance = computeColorLuminance(DARK_TEXT_COLOR);

  const whiteContrast = contrastRatio(colorLuminance, whiteLuminance);
  const blackContrast = contrastRatio(colorLuminance, blackLuminance);

  return blackContrast > whiteContrast ? DARK_TEXT_COLOR : BRIGHT_TEXT_COLOR;
});

/**
 * @see https://stackoverflow.com/questions/66123016/interpolate-between-two-colours-based-on-a-percentage-value
 *
 * @param color1 - color in hex format, for example 'fff' or '0cf' etc
 * @param color2 - color in hex format, for example 'fff' or '0cf' etc
 * @param percent - value from 0 to 1 of how much percent
 * @returns string representing color, like 'f6c'
 */
export function lerpColor(color1: string, color2: string, percent: number) {
  const [
    r1,
    g1,
    b1,
  ] = hexToRgbNumberArray(color1);
  const [
    r2,
    g2,
    b2,
  ] = hexToRgbNumberArray(color2);

  const q = 1 - percent;
  const rr = Math.round(r1 * percent + r2 * q);
  const rg = Math.round(g1 * percent + g2 * q);
  const rb = Math.round(b1 * percent + b2 * q);

  return Number((rr << 16) + (rg << 8) + rb).toString(16);
}

/**
 * @param cssColor - for example 'rbg(111,11,90)'
 * @returns
 */
export function extractRGBValues(cssColor: string) {
  const rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
  const match = cssColor.match(rgbRegex);
  if (match) {
    return match.slice(1).map(Number); // Convert strings to numbers
  }
  return null; // Return null if no match found
}

/**
 * Converts an opacity value (0-100) into a two-character hexadecimal string
 * representing the equivalent opacity in a 0-255 range for CSS color usage.
 * If the provided value is outside the 0-100 range, it will be clipped.
 *
 * @param {number} opacity - The opacity value between 0 and 100.
 * @returns {string} A two-character hex string (e.g., "00" to "FF").
 *
 * @example
 * // Returns "FF" since 100% opacity equals 255 in hex
 * opacityToHex(100);
 *
 * @example
 * // Returns "80" since 50% opacity equals approximately 128 (80 in hex)
 * opacityToHex(50);
 *
 * @example
 * // Returns "00" because -10 is clipped to 0
 * opacityToHex(-10);
 *
 * @example
 * // Returns "FF" because 150 is clipped to 100
 * opacityToHex(150);
 */
export function opacityToHex(opacity: number): string {
  // Clip the opacity to the range 0 to 100
  const clipped = Math.min(100, Math.max(0, opacity));
  // Convert to a value in the 0-255 range and round to the nearest integer
  const hexValue = Math.round((clipped / 100) * 255);
  // Convert to hex string, ensuring it is two characters long and uppercase
  return hexValue.toString(16).toUpperCase().padStart(2, '0');
}

/**
 * Returns the RGB portion of a hex color, discarding any alpha channel.
 *
 * Accepts 3, 4, 6 or 8 digit hex (with or without a leading '#') and always
 * returns a 6-digit '#rrggbb' string. Use it before appending a fresh
 * opacity/alpha so an already-alpha color does not become an invalid 10-digit
 * value.
 *
 * @param hexColor - hex color string, e.g. '#295bacff' or 'eeef'
 * @returns a 6-digit hex color string, e.g. '#295bac'
 *
 * @example
 * stripAlphaChannel('#295bacff'); // '#295bac'
 *
 * @example
 * stripAlphaChannel('#eeef'); // '#eeeeee'
 */
export function stripAlphaChannel(hexColor: string): string {
  const cleanHex = hexColor.replace(/^#/, '');
  if (cleanHex.length <= 4) {
    const [
      red,
      green,
      blue,
    ] = cleanHex;
    return `#${red}${red}${green}${green}${blue}${blue}`;
  }
  return `#${cleanHex.slice(0, 6)}`;
}

/** @see https://stackoverflow.com/questions/3426404/create-a-hexadecimal-colour-based-on-a-string-with-javascript */
export function stringToColorHex(str: string) {
  let hash = 0;
  str.split('').forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += value.toString(16).padStart(2, '0');
  }
  return colour;
}

/**
 * Creates a color generator function that returns visually distinct colors
 * from the Qmulus palette on each successive call.
 *
 * The generator steps through a filtered subset of the palette (controlled by
 * brightness bounds) using a configurable stride so that adjacent calls produce
 * colors that are far apart in the palette, maximizing visual distinction.
 *
 * When the end of the palette is reached the index wraps around with a small
 * random offset to avoid repeating the exact same sequence.
 *
 * @param options.step - Stride between picks in the palette (default 3).
 * @param options.minBrightness - Minimum WCAG relative luminance (0–1, default 0).
 * @param options.maxBrightness - Maximum WCAG relative luminance (0–1, default 0.5).
 * @returns A function that returns a new hex color string on each call.
 *
 * @example
 * const getNextColor = getRandomColorGenerator();
 * const color1 = getNextColor(); // e.g. "#3b82f6ff"
 * const color2 = getNextColor(); // e.g. "#22c55eff"
 *
 * @example
 * // Only pick dark colors
 * const getDarkColor = getRandomColorGenerator({ maxBrightness: 0.5 });
 */
export function getRandomColorGenerator(options: {
  step?: number,
  minBrightness?: number,
  maxBrightness?: number,
} = {}): () => string {
  let currentIndex = 0;
  let cycleStartIndex = 0;
  const step = options.step ?? 5;
  const minBrightness = options?.minBrightness ?? 0;
  // TODO(QMU-4568): adjust when theming will be introduced
  const maxBrightness = options.maxBrightness ?? 0.5;
  const filteredPaletteList = colorPaletteWithoutGrayscaleLuminiscenseList.filter((_color) =>
    _color.luminance >= minBrightness
    && _color.luminance <= maxBrightness);
  const palette = filteredPaletteList.length > 0 ? filteredPaletteList : colorPaletteWithoutGrayscaleLuminiscenseList;

  return () => {
    const newColor = palette[currentIndex];
    currentIndex += step;
    if (currentIndex >= palette.length) {
      // increment the starting index for each new cycle
      cycleStartIndex = (cycleStartIndex + 1) % palette.length;
      currentIndex = cycleStartIndex;
    }
    return newColor.cssColorValue;
  };
}

/**
 * Returns a single color from the Qmulus palette.
 *
 * When called with a numeric identifier, the returned color is deterministic —
 * the same ID always produces the same color. This is useful for assigning
 * stable colors to entities (jobs, KPIs, etc.) without maintaining a generator.
 *
 * When called without arguments, a random palette color is returned.
 *
 * @param identifier - Optional numeric value used to pick a deterministic color.
 * @param options.minBrightness - Minimum WCAG relative luminance (0–1, default 0).
 * @param options.maxBrightness - Maximum WCAG relative luminance (0–1, default 0.5).
 * @returns A hex color string from the palette.
 *
 * @example
 * // Deterministic: same ID always gives same color
 * getColorFromPalette(job.parentJobId);
 *
 * @example
 * // Deterministic with brightness constraint
 * getColorFromPalette(job.id, { minBrightness: 0.5 });
 *
 * @example
 * // Random pick
 * getColorFromPalette();
 */
export function getColorFromPalette(identifier?: number, options: {
  minBrightness?: number,
  maxBrightness?: number,
} = {}): string {
  const minBrightness = options.minBrightness ?? 0;
  // TODO(QMU-4568): adjust when theming will be introduced
  const maxBrightness = options.maxBrightness ?? 0.5;
  const filteredList = colorPaletteWithoutGrayscaleLuminiscenseList.filter((_color) =>
    _color.luminance >= minBrightness
    && _color.luminance <= maxBrightness);

  const palette = filteredList.length > 0 ? filteredList : colorPaletteWithoutGrayscaleLuminiscenseList;

  if (identifier === undefined) {
    const randomIndex = Math.floor(Math.random() * palette.length);
    return palette[randomIndex].cssColorValue;
  }
  const index = ((identifier % palette.length) + palette.length) % palette.length;
  return palette[index].cssColorValue;
}
